module.exports = __webpack_public_path__ + "static/media/IMG_20181128_211017.4fb5c3e6.jpg";